const _throttle = require('lodash.throttle');

window.addEventListener('load', () => {
    const faqPanels = document.querySelectorAll('.faq-panel');

    faqPanels.forEach(faqPanel => {
        const faqColumns = {
            1: faqPanel.querySelector('[data-faq-column="1"]'),
            2: faqPanel.querySelector('[data-faq-column="2"]'),
            3: faqPanel.querySelector('[data-faq-column="3"]')
        };

        // Check if this faq-panel is inside a category group (has data-content-heading sibling)
        const parentGroup = faqPanel.closest('[data-faq-group]');
        const hasContentHeading = parentGroup?.querySelector('[data-content-heading]') !== null;

        function distributeFAQs() {
            // Only get FAQ cards from this specific panel's columns
            // This prevents cards from being moved between different category groups
            const cardsInColumn1 = faqColumns[1] ? Array.from(faqColumns[1].querySelectorAll('[data-faq-card-index]')) : [];
            const cardsInColumn2 = faqColumns[2] ? Array.from(faqColumns[2].querySelectorAll('[data-faq-card-index]')) : [];
            const cardsInColumn3 = faqColumns[3] ? Array.from(faqColumns[3].querySelectorAll('[data-faq-card-index]')) : [];
            const faqCards = [...cardsInColumn1, ...cardsInColumn2, ...cardsInColumn3];

            // Sort FAQ cards by data-faq-card-index
            faqCards.sort((a, b) => parseInt(a.dataset.faqCardIndex) - parseInt(b.dataset.faqCardIndex));

            // Distribute FAQ cards based on media queries
            const windowWidth = window.innerWidth;

            if (windowWidth < 640) {
                faqCards.forEach(card => {
                    faqColumns[1].appendChild(card);
                });
            } else if (windowWidth >= 640) {
                faqCards.forEach((card, index) => {
                    const columnNumber = (index % 2) + 1;
                    faqColumns[columnNumber].appendChild(card);
                });
            }
        }

        const throttledDistributeFAQs = _throttle(distributeFAQs, 200);

        // Trigger distributeFAQs when the window resizes
        window.addEventListener('resize', () => {
            const windowWidth = window.innerWidth;

            // Check if media query actually changes (e.g., window width crosses the breakpoints)
            if ((windowWidth < 640 && window.prevWidth >= 640) ||
                (windowWidth >= 640 && windowWidth < 1024 && (window.prevWidth < 640 || window.prevWidth >= 1024)) ||
                (windowWidth >= 1024 && window.prevWidth < 1024)) {
                throttledDistributeFAQs();
            }
            window.prevWidth = windowWidth;
        });

        // Initial distribution of FAQ cards
        distributeFAQs();
    });
});
